// Integumentary subsection form field enum
export enum IntegumentaryFormField {
  INTEGUMENTARY_SKIN_COLOR = 'medical-background/integumentary/skin-color',
  INTEGUMENTARY_SKIN_ISSUES = 'medical-background/integumentary/skin-issues',
  INTEGUMENTARY_NAILS = 'medical-background/integumentary/nails',
  INTEGUMENTARY_IDENTIFIED_WOUNDS = 'medical-background/integumentary/identified-wounds',
  INTEGUMENTARY_WOUND_NOTES = 'medical-background/integumentary/wound-notes',
  INTEGUMENTARY_SYSTEM_SUMMARY = 'medical-background/integumentary/system-summary'
}
